// extracted by mini-css-extract-plugin
export default {"rootWrapper":"PositionUpdateForm_rootWrapper__SkpzP","rateWrapper":"PositionUpdateForm_rateWrapper__ABgpA"};